module.exports = __webpack_public_path__ + "static/img/freshman-blocky.20d99e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/he/freshman-blocky.png
// module id = Ullx
// module chunks = 1